import BaseService from './BaseService';
import * as apiroutes from '../apiRoutes';

class IncidentTypeService extends BaseService {
    constructor() {
        super(apiroutes.INCIDENT_TYPES);
    }
    async create(data) {
        return await super.create(data);
    }
    async update(id, data) {
        return await super.customCall('PUT', `/${id}`, data, null, 'json');
    }

    async delete(id) {
        return await super.delete(id)
    }

    async get(params = {}) {
        return await super.getAll(params)
    }
    async getAll(params = {}) {
        return await super.customCall("GET", '', null, params, null)
    }
    async getFromPost(params = {}) {
        return await super.getByPost(params)
    }

    async getById(id) {
        return await super.getById(id)
    }

    async search(searchTerm, filters = {}) {
        return await super.search(searchTerm, filters)
    }
}

const IncidentTypeServices = new IncidentTypeService();
export default IncidentTypeServices;
